<template>
  <v-row>
    <v-col cols="12" xl="9" lg="9" md="8" sm="12" style="padding-right: 0!important;">
      <div class="bordered canvas-container">
        <canvas id="canvas" style="border-radius: 15px;"></canvas>
      </div>
    </v-col>
    <v-col cols="12" xl="3" lg="3" md="4" sm="12" style="padding-left: 0!important;">
      <div class="bordered">
        <v-color-picker
            dot-size="10"
            swatches-max-height="200"
            v-model="color"
            hide-inputs
            style="margin: auto"
        ></v-color-picker>
        <v-slider
            :track-fill-color="colors.success"
            :color="colors.success"
            track-color="gray"
            max="100"
            v-model="width"
            min="1"
        ></v-slider>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "MeetingWhiteboard",

  props: ['colors'],

  data() {
    return {
      color: '#000',
      width: 2,
    }
  },

  mounted() {
    let self = this
    const canvas = document.getElementById("canvas");
    const ctx = canvas.getContext("2d");
    let coords = {x: 0, y: 0};

    canvas.addEventListener("mousedown", start);
    canvas.addEventListener("mouseup", stop);
    window.addEventListener("resize", resize);

    resize();

    function resize() {
      ctx.canvas.width = canvas.parentElement.offsetWidth - 10; // 10 is margin of parent
      ctx.canvas.height = canvas.parentElement.offsetHeight;
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    }

    function reposition(event) {
      const target = event.target;
      const rect = target.getBoundingClientRect();
      coords.x = event.clientX - rect.left;
      coords.y = event.clientY - rect.top;
    }

    function start(event) {
      canvas.addEventListener("mousemove", draw);
      reposition(event);
    }

    function stop() {
      canvas.removeEventListener("mousemove", draw);
    }

    function draw(event) {
      ctx.beginPath();
      ctx.lineWidth = self.width;
      ctx.lineCap = "round";
      ctx.strokeStyle = self.color;
      ctx.moveTo(coords.x, coords.y);
      reposition(event);
      ctx.lineTo(coords.x, coords.y);
      ctx.stroke();
    }
  }
}
</script>

<style scoped>
canvas {
  cursor: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'  width='40' height='48' viewport='0 0 100 100' style='fill:black;font-size:24px;'><text y='50%'>✍️</text></svg>") 5 25, auto;
}

.canvas-container {
  height: 100%;
  width: 100%;
  display: grid;
  align-content: center;
}

.bordered {
  padding: 5px;
  border: 1px solid black;
  border-radius: 15px;
}
</style>